export default "__VITE_PUBLIC_ASSET__61b189c4__"